// extracted by mini-css-extract-plugin
export default {"alert":"CdczlpBJRF3S7UEzq31i"};